import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ZoomIn = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ZoomIn' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,15 L10,5 M5,10 L15,10' />
  </StyledIcon>
);
